import React from "react";

export default function AutomatedPaymentToggle({
  checked = false,
  disabled = false,
  onClick,
}) {
  return (
    <button
      type="button"
      className={`bills-page__automation-toggle ${checked ? "is-active" : ""}`}
      aria-label={`${checked ? "Disable" : "Enable"} automated payment`}
      aria-pressed={checked}
      disabled={disabled}
      onClick={(event) => {
        event.stopPropagation();
        onClick?.();
      }}
    >
      <span />
    </button>
  );
}
